/**
 * CRA 部署在子路径时，public 下文件需带 PUBLIC_URL 前缀。
 * 否则 audioWorklet.addModule('/audio-processor.js') 可能请求错误地址（如返回 index.html），
 * 脚本未执行 registerProcessor，进而出现 “audio-processor is not defined”。
 */
export function publicAssetUrl(path: string): string {
  const base = typeof process !== 'undefined' && process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '';
  const normalizedBase = String(base).replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return normalizedBase ? `${normalizedBase}${p}` : p;
}
